/**
 * @file select2のフォームを増やす。
 */
'use strict'

import ApplyClass from '../../Utils/ApplyClass'
import Validate from '../../View/Form/Validate'
import Form from '../../Controller/Form'
import Select2 from '../../View/Form/Select2'

/**
 * @classname AddRecommendForm
 * @classdesc select2のフォームを増やす。
 */
export default class AddRecommendForm {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-toggle-password')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this.FormController = new Form()
		this._$e = $e
		this._$trigger = this._$e.find('[data-template-area-type="trigger"]')
		this._$area = this._$e.find('[data-template-area-type="area"]')
		this._$copyEl = this.createCopyElement()
		// 初期表示時にあるの増やしてあるformの数分countを増やしておく、クリックされたら+1されるため初期値は1減らしとく
		this.createdCount = this._$area.children().length - 1
		this._$trigger.on('click', () => this.onClick())
		const $delBtn = this._$e.find('[data-template-area-type="delete"]')
		$delBtn.on('click', (e) => this.onClickDelete(e))
	}

	/**
	 * onClickのコールバック
	 *
	 * @memberof AddRecommendForm
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`)
		const actionCount = this.createdCount + 1
		this.createdCount = actionCount
		const cloneElement = this._$copyEl.clone()

		// name属性書き換え
		const nameAttr = this._$area.children().first().find('select.select2').attr('name')
		const splittedNameAttr = nameAttr.split('[0]')
		if (2 <= splittedNameAttr.length) {
			const newNameAttr = `${splittedNameAttr[0]}[${this.createdCount}]${splittedNameAttr[1]}`
			cloneElement.find('.select2').attr('name', newNameAttr)
		}

		this._$area.append(cloneElement)

		// 追加した要素のみを指定したいので last()をつけてる
		const $delBtn = this._$e.find('[data-template-area-type="delete"]').last()
		const $addedElement = this._$e.find('[data-template-area-type="delete-target"]').last()
		$delBtn.on('click', (e) => this.onClickDelete(e))
		this.applyClass($addedElement)
	}

	/**
	 * コピーを作成
	 *
	 * @memberof AddRecommendForm
	 * @return {undefined}
	 */
	createCopyElement() {
		console.log(`${this.constructor.name}.createCopyElement`)
		const $copyElement = $(`<div class="row form-group" data-template-area-type="delete-target">
		<div class="col-12 flex justify-start items-center ml-4 mb-4">おすすめ案件</div>
		<div class="col-12" style="display:flex">
			<div class="input-select select2-wrap" style="width: 100%"><select class="validate input-select select2" name="" data-validate="empty">
				</select><p class="error-tip"><span class="error-tip-inner"></span></p></div>
				<button class="hidden self-center btn btn-secondary" style="margin-left: 12px" data-template-area-type="delete" type="button">-</button></div>
	</div>`)
		const copySource = this._$area.children().first().find('select.select2')

		// option追加
		copySource.find('option').each((index, el) => {
			const $el = $(el)
			const optionValue = $el.val()
			const optionText = $el.text()
			// そのまま$elを入れると、select2独特の属性が付いてしまうのでそうならないため、個別でvalueとtext取ってきてる
			$copyElement.find('.select2').append(`<option value="${optionValue}">${optionText}</option>`)
		})

		// 削除ボタン表示
		$copyElement.find('[data-template-area-type="delete"]').removeClass('hidden')

		return $copyElement
	}

	/**
	 * onClickのコールバック
	 *
	 * @memberof AddRecommendForm
	 * @return {undefined}
	 */
	onClickDelete(e) {
		console.log(`${this.constructor.name}.onClickDelete`, e.target, $(e.target))
		const deleteTarget = $(e.target).closest('[data-template-area-type="delete-target"]')
		deleteTarget.remove()
		console.log(deleteTarget.length)
	}

	/**
	 * 追加したテンプレートのパーツにapplyClassする
	 *
	 * @memberof AddRecommendForm
	 * @return {undefined}
	 */
	applyClass($addedElement) {
		console.log(`${this.constructor.name}.applyClass`)
		// バリデート
		$addedElement.find('.validate').each((idx, e) => {
			const $e = $(e)
			ApplyClass.apply(Validate, $e, [$e, this.FormController])
		})
		// select2
		$addedElement.find('.select2').each((idx, e) => {
			const $e = $(e)
			ApplyClass.apply(Select2, $e, [$e, this.FormController])
		})
	}
}
